import testimonialsData from "../data/testimonialsData";
import { StaggerTestimonials } from "./ui/StaggerTestimonials";

function Testimonials() {
  if (testimonialsData.length === 0) return null;

  return (
    <section id="sobre" className="py-24">
      <div className="max-w-6xl mx-auto px-6 mb-12 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-primary">
          Lo que dicen nuestros clientes
        </h2>
        <p className="mt-4 text-gray-500 max-w-lg mx-auto">
          Relaciones de confianza construidas proyecto a proyecto.
        </p>
      </div>
      <StaggerTestimonials testimonials={testimonialsData} />
    </section>
  );
}

export default Testimonials;
